// extracted by mini-css-extract-plugin
export default {"selectorContainer":"style_selectorContainer__ohaPW","selectorText":"style_selectorText__E5DB9"};